module.exports = __webpack_public_path__ + "img/mq.75f2db2f.svg";